export interface RoiField {
  key: string;
  label: string;
}

export const METRICS_FIELDS: RoiField[] = [
  { key: 'num_agents', label: 'Number of Agents' },
  { key: 'agent_salary', label: 'Average Agent Salary ($)' },
  { key: 'annual_inbound_calls', label: 'Annual Inbound Calls' },
  { key: 'annual_outbound_calls', label: 'Annual Outbound Calls' },
  { key: 'avg_handle_time', label: 'Average Handle Time (min)' },
  { key: 'conversion_rate', label: 'Current Conversion Rate (%)' },
  { key: 'revenue_per_opportunity', label: 'Revenue per Opportunity ($)' },
  { key: 'it_fte', label: 'IT FTEs Supporting CC' },
  { key: 'qa_fte', label: 'QA FTEs' },
  { key: 'wfm_fte', label: 'WFM FTEs' }
];

export const SUPPLIER_PROPOSAL_FIELDS: RoiField[] = [
  { key: 'proposed_monthly_cost', label: 'Proposed Monthly Cost' },
  { key: 'implementation_cost', label: 'Implementation Cost' },
  { key: 'aht_reduction_pct', label: 'AHT Reduction (%)' },
  { key: 'deflection_rate_pct', label: 'Call Deflection (%)' },
  { key: 'conversion_improvement_pct', label: 'Conversion Improvement (%)' },
  { key: 'fte_reduction_pct', label: 'FTE Reduction (%)' },
  { key: 'attrition_reduction_pct', label: 'Attrition Reduction (%)' }
];
